
import React, { createContext } from 'react';

const TimerContext = createContext(null);

export default TimerContext;